import { AdminApiService } from '../services/general';

export type GetMessagesFilter = { contactId?: string };

export const getMessages = async (filter?: GetMessagesFilter) => {
  if (!filter?.contactId) return [];

  return AdminApiService.getMessageHistoryApiAdminContactsContactIdMessageHistoryGet(
    filter.contactId,
    200
  );
};

export type { MessageHistoryEntry as MessageItem } from '../services/general';
